/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { getAttributes } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

export const clickHandler = (options) => {
    return new Plugin({
        key: new PluginKey("handleClickLink"),
        props: {
            handleClick: (view, pos, event) => {
                if (event.button !== 0) {
                    return false;
                }

                if (!view.editable) {
                    return false;
                }

                let link;

                if (event.target instanceof HTMLAnchorElement) {
                    link = event.target;
                } else {
                    let a = event.target;
                    const els = [];

                    while (a.nodeName !== "DIV") {
                        els.push(a);
                        a = a.parentNode;
                    }
                    link = els.find((value) => value.nodeName === "A");
                }

                if (!link) {
                    return false;
                }

                const attrs = getAttributes(view.state, options.type.name);
                const href = link?.href ?? attrs.href;
                const target = link?.target ?? attrs.target;

                if (options.enableClickSelection) {
                    options.editor.commands.extendMarkRange(options.type.name);
                }

                if (link && href) {
                    window.open(href, target);

                    return true;
                }

                return false;
            },
        },
    });
};
